<template>
    <div class="page-holder bg-light">
        <!--  Modal -->
        <div class="modal fade" id="productView" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body p-0">
                <div class="row align-items-stretch">
                    <div class="col-lg-6 p-lg-0"><a class="product-view d-block h-100 bg-cover bg-center" style="background: url(img/product-5.jpg)" href="img/product-5.jpg" data-lightbox="productview" title="Red digital smartwatch"></a><a class="d-none" href="img/product-5-alt-1.jpg" title="Red digital smartwatch" data-lightbox="productview"></a><a class="d-none" href="img/product-5-alt-2.jpg" title="Red digital smartwatch" data-lightbox="productview"></a></div>
                    <div class="col-lg-6">
                    <button class="close p-4" type="button" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                    <div class="p-5 my-md-4">
                        <ul class="list-inline mb-2">
                        <li class="list-inline-item m-0"><i class="fas fa-star small text-warning"></i></li>
                        <li class="list-inline-item m-0"><i class="fas fa-star small text-warning"></i></li>
                        <li class="list-inline-item m-0"><i class="fas fa-star small text-warning"></i></li>
                        <li class="list-inline-item m-0"><i class="fas fa-star small text-warning"></i></li>
                        <li class="list-inline-item m-0"><i class="fas fa-star small text-warning"></i></li>
                        </ul>
                        <h2 class="h4">Red digital smartwatch</h2>
                        <p class="text-muted">$250</p>
                        <p class="text-small mb-4">Lorem ipsum dolor sit amet, consectetur adipiscing elit. In ut ullamcorper leo, eget euismod orci. Cum sociis natoque penatibus et magnis dis parturient montes nascetur ridiculus mus. Vestibulum ultricies aliquam convallis.</p>
                        <div class="row align-items-stretch mb-4">
                        <div class="col-sm-7 pr-sm-0">
                            <div class="border d-flex align-items-center justify-content-between py-1 px-3"><span class="small text-uppercase text-gray mr-4 no-select">Quantity</span>
                            <div class="quantity">
                                <button class="dec-btn p-0"><i class="fas fa-caret-left"></i></button>
                                <input class="form-control border-0 shadow-0 p-0" type="text" value="1">
                                <button class="inc-btn p-0"><i class="fas fa-caret-right"></i></button>
                            </div>
                            </div>
                        </div>
                        <div class="col-sm-5 pl-sm-0"><a class="btn btn-dark btn-sm btn-block h-100 d-flex align-items-center justify-content-center px-0" href="cart.html">Add to cart</a></div>
                        </div><a class="btn btn-link text-dark p-0" href="#"><i class="far fa-heart mr-2"></i>Add to wish list</a>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        <section class="py-5">
            <div class="container">
            <div class="row mb-5">
                <div class="col-lg-6">
                    <!-- PRODUCT SLIDER-->
                    <div class="row m-sm-0">
                        <div class="col-sm-2 p-sm-0 order-2 order-sm-1 mt-2 mt-sm-0" :class="is_show_thumnail">
                            <div class="owl-thumbs d-flex flex-row flex-sm-column" data-slider-id="1">
                                <div class="owl-thumb-item flex-fill mb-2 mr-2 mr-sm-0" v-for="data in more_image" :key="data.id">
                                    <img class="w-100" v-bind:src="data.image" :alt="data.id">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-10 order-1 order-sm-2">
                            <div class="owl-carousel product-slider" data-slider-id="1">
                                <a class="d-block" :href="data.image" data-lightbox="product" v-for="(data, index) in more_image" :key="index" :title="prod_datas.name">
                                    <img class="img-fluid" v-bind:src="data.image" :alt="data.id">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- PRODUCT DETAILS-->
                <div class="col-lg-6">
                <ul class="list-inline mb-2">
                    <li class="list-inline-item m-0"><i class="fas fa-star small text-warning"></i></li>
                    <li class="list-inline-item m-0"><i class="fas fa-star small text-warning"></i></li>
                    <li class="list-inline-item m-0"><i class="fas fa-star small text-warning"></i></li>
                    <li class="list-inline-item m-0"><i class="fas fa-star small text-warning"></i></li>
                    <li class="list-inline-item m-0"><i class="fas fa-star small text-warning"></i></li>
                </ul>
                <h1>{{prod_datas.name}}</h1>
                <p class="text-muted lead">${{prod_datas.price}}</p>
                <p class="text-small mb-4" style="white-space:pre-wrap;">{{prod_datas.description}}</p>
                <div class="row align-items-stretch mb-4">
                    <div class="col-sm-5 pr-sm-0">
                        <div class="border d-flex align-items-center justify-content-between py-1 px-3 bg-white border-white"><span class="small text-uppercase text-gray mr-4 no-select">Quantity</span>
                            <div class="quantity">
                            <button class="dec-btn p-0"><i class="fas fa-caret-left"></i></button>
                            <input class="form-control border-0 shadow-0 p-0" type="text" value="1">
                            <button class="inc-btn p-0"><i class="fas fa-caret-right"></i></button>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div class="row align-items-stretch mb-4">
                    <div class="col-sm-5 pl-sm-0">
                        <!-- <a class="btn btn-dark btn-sm btn-block h-100 d-flex align-items-center justify-content-center px-0" href="cart.html">Add to cart</a> -->
                        <a style="padding-left: 0%;" id="msnnr_btn_anc" href="https://m.me/101727785111824?fbclid=IwAR2OQ3lB4Gz83gVNld8xISKUmZctmRK6bBo3-_t3fgxCCMyCIN3keh_5KSw" target="_blank">
                            <div id="messenger_button">
                            <div class="messenger_column btn_icon">
                                <img src="img/msg_icon.svg" id="msngr_btn_icon">
                            </div>
                            <div class="messenger_column btn_label">
                                <span>Message Us</span>
                            </div>
                            </div>
                        </a>
                    </div>
                </div>
                <!-- <a class="btn btn-link text-dark p-0 mb-4" href="#"><i class="far fa-heart mr-2"></i>Add to wish list</a> -->
                <br>
                <ul class="list-unstyled small d-inline-block">
                    <!-- <li class="px-3 py-2 mb-1 bg-white"><strong class="text-uppercase">SKU:</strong><span class="ml-2 text-muted">039</span></li> -->
                    <li class="px-3 py-2 mb-1 bg-white text-muted"><strong class="text-uppercase text-dark">Category:</strong><a class="reset-anchor ml-2" href="#">{{prod_datas.cat}}</a></li>
                    <li class="px-3 py-2 mb-1 bg-white text-muted"><strong class="text-uppercase text-dark">Tags:</strong><a class="reset-anchor ml-2" href="#">Innovation</a></li>
                </ul>
                </div>
            </div>
            <!-- DETAILS TABS-->
            <ul class="nav nav-tabs border-0" id="myTab" role="tablist">
                <li class="nav-item"><a class="nav-link active" id="description-tab" data-toggle="tab" href="#description" role="tab" aria-controls="description" aria-selected="true">Description</a></li>
                <li class="nav-item"><a class="nav-link" id="reviews-tab" data-toggle="tab" href="#reviews" role="tab" aria-controls="reviews" aria-selected="false">Reviews</a></li>
            </ul>
            <div class="tab-content mb-5" id="myTabContent">
                <div class="tab-pane fade show active" id="description" role="tabpanel" aria-labelledby="description-tab">
                <div class="p-4 p-lg-5 bg-white">
                    <h6 class="text-uppercase">Product description </h6>
                    <p class="text-muted text-small mb-0" style="white-space:pre-wrap;">{{prod_datas.description}}</p>
                </div>
                </div>
                <div class="tab-pane fade" id="reviews" role="tabpanel" aria-labelledby="reviews-tab">
                <div class="p-4 p-lg-5 bg-white">
                    <div class="row" style="display:none;">
                        <div class="col-lg-8">
                            <div class="media mb-3"><img class="rounded-circle" src="img/customer-1.png" alt="" width="50">
                            <div class="media-body ml-3">
                                <h6 class="mb-0 text-uppercase">Jason Doe</h6>
                                <p class="small text-muted mb-0 text-uppercase">20 May 2020</p>
                                <ul class="list-inline mb-1 text-xs">
                                <li class="list-inline-item m-0"><i class="fas fa-star text-warning"></i></li>
                                <li class="list-inline-item m-0"><i class="fas fa-star text-warning"></i></li>
                                <li class="list-inline-item m-0"><i class="fas fa-star text-warning"></i></li>
                                <li class="list-inline-item m-0"><i class="fas fa-star text-warning"></i></li>
                                <li class="list-inline-item m-0"><i class="fas fa-star-half-alt text-warning"></i></li>
                                </ul>
                                <p class="text-small mb-0 text-muted">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                            </div>
                            </div>
                            <div class="media">
                                <img class="rounded-circle" src="img/customer-2.png" alt="" width="50">
                                <div class="media-body ml-3">
                                    <h6 class="mb-0 text-uppercase">Jason Doe</h6>
                                    <p class="small text-muted mb-0 text-uppercase">20 May 2020</p>
                                    <ul class="list-inline mb-1 text-xs">
                                    <li class="list-inline-item m-0"><i class="fas fa-star text-warning"></i></li>
                                    <li class="list-inline-item m-0"><i class="fas fa-star text-warning"></i></li>
                                    <li class="list-inline-item m-0"><i class="fas fa-star text-warning"></i></li>
                                    <li class="list-inline-item m-0"><i class="fas fa-star text-warning"></i></li>
                                    <li class="list-inline-item m-0"><i class="fas fa-star-half-alt text-warning"></i></li>
                                    </ul>
                                    <p class="text-small mb-0 text-muted">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            <!-- RELATED PRODUCTS-->
            <h2 class="h5 text-uppercase mb-4">Related products</h2>
            <div class="row">
                <!-- PRODUCT-->
                <div class="col-xl-3 col-lg-4 col-6"  v-for="data in proData.datas_list" :key="data.id">
                    <div class="product text-center">
                        <div class="position-relative mb-3">
                            <div class="badge text-white badge-danger">{{data.status}}</div>
                            <a class="d-block" :href="'/detail?proId='+data.id+'&price='+data.price+'&cat='+data.cat">
                                <img class="img-fluid w-100" v-bind:src="data.image" :alt="data.name">
                            </a>
                            <div class="product-overlay">
                                <ul class="mb-0 list-inline">
                                <!-- <li class="list-inline-item m-0 p-0"><a class="btn btn-sm btn-outline-dark" href="#"><i class="far fa-heart"></i></a></li>
                                <li class="list-inline-item m-0 p-0"><a class="btn btn-sm btn-dark" href="cart.html">Add to cart</a></li> -->
                                <!-- <li class="list-inline-item mr-0">
                                    <a class="btn btn-sm btn-outline-dark" href="#productView" data-toggle="modal" @click="preview(data)"> 
                                    <i class="fas fa-expand"></i>
                                    </a>
                                </li> -->
                                </ul>
                            </div>
                        </div>

                        <!-- href="detail.html" -->
                        <h6> <a class="reset-anchor" :href="'/detail?proId='+data.id">{{data.name}}</a></h6>
                        <!-- <small><del class="small text-muted">${{data.origin_price}}</del></small> -->
                        <p class="small text-muted"><del class="small text-muted">${{data.origin_price}}</del> ${{data.price}}</p>
                        <!-- <div class="fb-messengermessageus mb-3" messenger_app_id="312964843506855" page_id="101727785111824" color="blue" size="xlarge">
                        </div> -->
                        <!-- <div style="background-color: #eeeeee;">
                        <a href="https://m.me/101727785111824?fbclid=IwAR2OQ3lB4Gz83gVNld8xISKUmZctmRK6bBo3-_t3fgxCCMyCIN3keh_5KSw" target="_blank">
                            <img style=" width: 10%; height: 10%;" src="http://store-images.s-microsoft.com/image/apps.7488.13510798886918977.69182166-f125-495d-80d2-44fdaab21523.8fcea13e-5d9a-48a9-9937-b26deeced1b5">
                            Message Us
                        </a>
                        </div> -->
                        <div>
                        <a id="msnnr_btn_anc" href="https://m.me/101727785111824?fbclid=IwAR2OQ3lB4Gz83gVNld8xISKUmZctmRK6bBo3-_t3fgxCCMyCIN3keh_5KSw" target="_blank">
                            <div id="messenger_button">
                            <div class="messenger_column btn_icon">
                                <img src="img/msg_icon.svg" id="msngr_btn_icon">
                            </div>
                            <div class="messenger_column btn_label">
                                <span>Message Us</span>
                            </div>
                            </div>
                        </a>
                        </div>
                        <div class="mb-3"><br/><br/><br/></div>
                    </div>
                </div>
            </div>
            </div>
        </section>
    </div>
</template>

<script>
import {onUnmounted, reactive} from 'vue'
import { db } from '../firebase'
import { useRoute } from 'vue-router'

export default {

    mounted() {
        /* if(this.$route.params.id === null) {
            this.$router.push('/');
        } */
        db.collection("product").doc(this.proData.proId).get().then((querySnapshot) => {
            /* querySnapshot.forEach((doc) => {
                //console.log(`${doc.id} => ${doc.data().name}`);
                db.collection("product").doc(doc.id).collection("image").get().then((snap) => {
                    var image_data = snap.docs.map(docs => ({ ...docs.data() }));
                    var tmp = querySnapshot.docs.map(doc => ({ id: doc.id, image: image_data, ...doc.data() }));
                    console.log(tmp);
                });
            }); */

            this.prod_datas = querySnapshot.data();

            // copy array elements to th object
            //console.log(this.prod_datas.more_image)
            if (this.prod_datas.more_image != undefined) {
                // create a new empty object
                const obj = [];
                for (let i = 0; i < this.prod_datas.more_image.length; i++) {
                    obj[i] = {id:i, image:this.prod_datas.more_image[i]};
                }
                this.more_image = obj;
            }
            else {
                this.more_image = [{ id: 0, image: this.prod_datas.image }];
                this.is_show_thumnail = "isShowThumnail";
            }

            // Show og:image content image
            let aa = document.createElement('meta');
            aa.setAttribute('content', this.prod_datas.image);
            aa.setAttribute('property', 'og:image');
            document.head.appendChild(aa);

        });
    },
    data() {
        return {
            more_image:[
                { id: 0, image:"img/product-detail-1-.jpg" },
                { id: 1, image:"img/product-detail-2-.jpg" },
                { id: 2, image:"img/product-detail-3-.jpg" }
            ],
            prod_datas: {},
            is_show_thumnail: ""
        }
    },
    setup() {
        //const router = useRouter();
        const route = useRoute();
        const productId = route.query.proId;

        //console.log(productId);

        if(productId == null) {
            //console.log(productId);
        }

        const proData = reactive({
            datas_list: [],
            prod_datas: {},
            item_detail: {},
            proId: productId
        });

        const getData = db.collection("product").limit(4).get().then((querySnapshot) => {
            /* querySnapshot.forEach((doc) => {
                //console.log(`${doc.id} => ${doc.data().name}`);
                db.collection("product").doc(doc.id).collection("image").get().then((snap) => {
                    var image_data = snap.docs.map(docs => ({ ...docs.data() }));
                    var tmp = querySnapshot.docs.map(doc => ({ id: doc.id, image: image_data, ...doc.data() }));
                    console.log(tmp);
                });
            }); */
            proData.datas_list = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            //console.log(proData.datas_list);
        });

        // const getDataById = db.collection("product").doc(productId).get().then((querySnapshot) => {
        //     /* querySnapshot.forEach((doc) => {
        //         //console.log(`${doc.id} => ${doc.data().name}`);
        //         db.collection("product").doc(doc.id).collection("image").get().then((snap) => {
        //             var image_data = snap.docs.map(docs => ({ ...docs.data() }));
        //             var tmp = querySnapshot.docs.map(doc => ({ id: doc.id, image: image_data, ...doc.data() }));
        //             console.log(tmp);
        //         });
        //     }); */
        //     proData.prod_datas = querySnapshot.data();
        //     //proData.prod_datas.more_image = Object.assign({}, proData.prod_datas.more_image);

        //     /* // create a new empty object
        //     const obj = [];

        //     // copy array elements to th object
        //     for (let i = 0; i < proData.prod_datas.more_image.length; i++) {
        //         obj[i] = {id:i, image:proData.prod_datas.more_image[i]};
        //     }
        //     proData.prod_datas.more_image = obj; */

        //     // Show og:image content image
        //     let aa = document.createElement('meta');
        //     aa.setAttribute('content', proData.prod_datas.image);
        //     aa.setAttribute('property', 'og:image');
        //     document.head.appendChild(aa);

        //     //console.log(proData.prod_datas.more_image);
        // });

        const preview = (item) => {
            proData.item_detail = item;      
        };

        onUnmounted(getData);

        

        return {
            proData,
            getData,
            //getDataById,
            preview
        };

    }

}
</script>

<style scoped>
    .isShowThumnail {
        display:none;
    }
</style>
